import { render, staticRenderFns } from "./openappTest.vue?vue&type=template&id=8bf842f4&"
import script from "./openappTest.vue?vue&type=script&lang=js&"
export * from "./openappTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports